/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * User unique identifier
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * Firebase UID
     * @type {string}
     * @memberof UserDto
     */
    'firebaseUid': string;
    /**
     * First name
     * @type {string}
     * @memberof UserDto
     */
    'firstName': string;
    /**
     * Middle name
     * @type {string}
     * @memberof UserDto
     */
    'middleName'?: string;
    /**
     * Last name
     * @type {string}
     * @memberof UserDto
     */
    'lastName': string;
    /**
     * Nickname
     * @type {string}
     * @memberof UserDto
     */
    'nickName'?: string;
    /**
     * Birth date
     * @type {string}
     * @memberof UserDto
     */
    'birthDate'?: string;
    /**
     * Mobile number
     * @type {string}
     * @memberof UserDto
     */
    'mobileNumber'?: string;
    /**
     * Email address
     * @type {string}
     * @memberof UserDto
     */
    'email': string;
    /**
     * Profile photo URL
     * @type {string}
     * @memberof UserDto
     */
    'profilePhotoUrl'?: string;
    /**
     * Whether user has completed onboarding
     * @type {boolean}
     * @memberof UserDto
     */
    'hasOnboarded': boolean;
    /**
     * Login method used by the user
     * @type {string}
     * @memberof UserDto
     */
    'loginMethod': string;
    /**
     * Current status of the user account
     * @type {string}
     * @memberof UserDto
     */
    'status': UserDtoStatusEnum;
    /**
     * Full name
     * @type {string}
     * @memberof UserDto
     */
    'fullName': string;
    /**
     * Role of the user
     * @type {string}
     * @memberof UserDto
     */
    'role': UserDtoRoleEnum;
    /**
     * Name of the organization the user is a member of
     * @type {string}
     * @memberof UserDto
     */
    'organizationName'?: string;
    /**
     * Primary organization ID of the user (if applicable)
     * @type {string}
     * @memberof UserDto
     */
    'organizationId'?: string;
    /**
     * Strava user ID
     * @type {string}
     * @memberof UserDto
     */
    'stravaUserId'?: string;
    /**
     * Strava connection timestamp
     * @type {string}
     * @memberof UserDto
     */
    'stravaConnectedAt'?: string;
    /**
     * Last Strava sync timestamp
     * @type {string}
     * @memberof UserDto
     */
    'stravaLastSyncAt'?: string;
    /**
     * Whether user is connected to Strava
     * @type {boolean}
     * @memberof UserDto
     */
    'isStravaConnected'?: boolean;
    /**
     * Garmin user ID
     * @type {string}
     * @memberof UserDto
     */
    'garminUserId'?: string;
    /**
     * Garmin connection timestamp
     * @type {string}
     * @memberof UserDto
     */
    'garminConnectedAt'?: string;
    /**
     * Last Garmin sync timestamp
     * @type {string}
     * @memberof UserDto
     */
    'garminLastSyncAt'?: string;
    /**
     * Whether user is connected to Garmin
     * @type {boolean}
     * @memberof UserDto
     */
    'isGarminConnected'?: boolean;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof UserDto
     */
    'createdAt': string;
    /**
     * Last update timestamp
     * @type {string}
     * @memberof UserDto
     */
    'updatedAt': string;
}

export const UserDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Deleted: 'deleted'
} as const;

export type UserDtoStatusEnum = typeof UserDtoStatusEnum[keyof typeof UserDtoStatusEnum];
export const UserDtoRoleEnum = {
    SuperAdmin: 'super-admin',
    Admin: 'admin',
    OrganizationMember: 'organization-member',
    Organizer: 'organizer',
    User: 'user'
} as const;

export type UserDtoRoleEnum = typeof UserDtoRoleEnum[keyof typeof UserDtoRoleEnum];


